/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useRef } from 'react'
import { toast } from 'react-toastify'
import axios from 'axios'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ReCAPTCHA from 'react-google-recaptcha'

const InquiryOfListing = ({ propertyName, propertyUrl }) => {
    // Form state
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [comment, setComment] = useState(`I'm interested in [${propertyName}]`)

    // Error states
    const [nameError, setNameError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [phoneError, setPhoneError] = useState('')
    const [captchaError, setCaptchaError] = useState('')

    // Captcha verification state
    const [verified, setVerified] = useState(false)

    const refform = useRef()

    // Name validation - only letters and min 3 characters
    const validateName = (value) => {
        const nameRegex = /^[A-Za-z\s]+$/
        if (!value) {
            setNameError('Name is required')
            return false
        } else if (value.length < 3) {
            setNameError('Name must be at least 3 characters')
            return false
        } else if (!nameRegex.test(value)) {
            setNameError('Name should contain only letters')
            return false
        } else {
            setNameError('')
            return true
        }
    }

    // Email validation
    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!value) {
            setEmailError('Email is required')
            return false
        } else if (!emailRegex.test(value)) {
            setEmailError('Please enter a valid email address')
            return false
        } else {
            setEmailError('')
            return true
        }
    }

    // Phone validation
    const validatePhone = (value) => {
        if (!value) {
            setPhoneError('Phone number is required')
            return false
        } else {
            setPhoneError('')
            return true
        }
    }

    // Handle field blur events for validation
    const handleNameBlur = () => validateName(name)
    const handleEmailBlur = () => validateEmail(email)
    const handlePhoneBlur = () => validatePhone(phone)

    function onChange(value) {
        console.log('Captcha value:', value)
        setVerified(!!value)
        setCaptchaError('')
    }

    const handleSendForm = async (e) => {
        e.preventDefault()

        // Validate all fields before submission
        const isNameValid = validateName(name)
        const isEmailValid = validateEmail(email)
        const isPhoneValid = validatePhone(phone)

        // Check captcha
        if (!verified) {
            setCaptchaError('Please verify that you are not a robot')
            return
        }

        if (!isNameValid || !isEmailValid || !isPhoneValid) {
            return
        }

        const btn = document.getElementById('submit-btn')
        btn.disabled = true
        //loading spinner
        btn.innerHTML = `<div class="spinner-border spinner-border-sm" role="status"> <span class="visually-hidden">Loading...</span> </div>`

        const data = {
            name,
            email,
            phone,
            comment,
            property_url: propertyUrl,
        }

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/leads`, data)

            if (res.data.status === 201) {
                toast.success('Inquiry sent successfully')
                handleClearForm()
            } else {
                toast.error('Something went wrong')
            }
        } catch (error) {
            toast.error('Something went wrong')
        } finally {
            btn.disabled = false
            btn.innerHTML = 'Submit'
        }
    }

    const handleClearForm = () => {
        setName('')
        setEmail('')
        setPhone('')
        setComment(`I'm interested in [${propertyName}]`)
        setVerified(false)
    }

    return (
        <>
            <section className="container-fluid bg-grey-2 rounded-0 px-0">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12">
                        <div className="fs-ss-22 fw-500 lh-sm text-white pb-4 text-center">Inquiry - 800 Homes</div>
                        <div className="">
                            <form
                                ref={refform}
                                onSubmit={handleSendForm}
                                id="contactForm"
                                method="POST"
                                action="#"
                                className=""
                            >
                                <div className="form-group mb-3">
                                    <input
                                        type="text"
                                        className={`form-control fs-ss-16 fw-300 ${nameError ? 'is-invalid' : ''}`}
                                        id="name"
                                        name="name"
                                        placeholder="Name *"
                                        required
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        onBlur={handleNameBlur}
                                    />
                                    {nameError && <div className="invalid-feedback">{nameError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <input
                                        type="email"
                                        className={`form-control fs-ss-16 fw-300 ${emailError ? 'is-invalid' : ''}`}
                                        id="email"
                                        name="email"
                                        placeholder="Email *"
                                        required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onBlur={handleEmailBlur}
                                    />
                                    {emailError && <div className="invalid-feedback">{emailError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <PhoneInput
                                        country={'ae'}
                                        value={phone}
                                        onChange={(phone) => setPhone(phone)}
                                        onBlur={handlePhoneBlur}
                                        inputProps={{
                                            name: 'phone_number',
                                            id: 'phone_number',
                                            required: true,
                                            className: `w-100 bg-transparent rounded-0 border-bottom border-0 border-white text-grey fs-ss-16 fw-300 ps-5 ${
                                                phoneError ? 'is-invalid' : ''
                                            }`,
                                            placeholder: 'Phone Number *',
                                        }}
                                        containerStyle={{
                                            width: '100%',
                                        }}
                                        enableSearch={true}
                                        buttonStyle={{
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                        }}
                                        dropdownStyle={{
                                            width: '300px',
                                        }}
                                    />
                                    {phoneError && <div className="invalid-feedback d-block">{phoneError}</div>}
                                </div>
                                <div className="form-group mb-4">
                                    <textarea
                                        className="form-control fs-ss-16 fw-300"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        id="message"
                                        name="message"
                                        rows="4"
                                        placeholder="Message"
                                    ></textarea>
                                </div>
                                <div className="">
                                    <ReCAPTCHA sitekey="6LdX3UgqAAAAAMWqmjHfeiVGKr_oLcfyYrNEu8KH" onChange={onChange} />
                                    {captchaError && <div className="text-danger mb-2">{captchaError}</div>}
                                    <button
                                        className="mt-2 text-center text-white fw-300 bg-ss-primary bg-hover-ss-primary rounded-0 border-0 text-ss-secondary fs-ss-16 px-3 py-ss-2 w-100"
                                        id="submit-btn"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                            <div className="d-flex">
                                <div className="w-50 pe-1">
                                    <a
                                        href="tel:+971585746637"
                                        className="d-block text-decoration-none mt-2 text-center text-white fw-300 border-ss-primary bg-hover-ss-primary rounded-0 fs-ss-16 px-3 py-ss-2 w-100"
                                    >
                                        Call
                                    </a>
                                </div>
                                <div className="w-50 ps-1">
                                    <a
                                        target="_blank"
                                        href="https://api.whatsapp.com/send/?phone=971585746637&text&type=phone_number&app_absent=0"
                                        className="d-block text-decoration-none mt-2 text-center text-white fw-300 border-ss-primary bg-hover-ss-primary rounded-0 fs-ss-16 px-3 py-ss-2 w-100"
                                    >
                                        WhatsApp
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InquiryOfListing
